module.exports = kolibriCoreAppGlobal;